const activeStreams = new Set<MediaStream>();

export function registerStream(stream: MediaStream): void {
  activeStreams.add(stream);
}

export function unregisterStream(stream: MediaStream): void {
  activeStreams.delete(stream);
}

export function closePipWindow(): void {
  try {
    const docPip = (window as any).documentPictureInPicture;
    if (docPip?.window && !docPip.window.closed) {
      docPip.window.close();
    }
  } catch (err) {
  }
}

export function stopAllActiveStreams(): void {
  closePipWindow();
  
  activeStreams.forEach((stream) => {
    stream.getTracks().forEach((track) => {
      if (track.readyState === 'live') {
        track.stop();
      }
    });
  });
  activeStreams.clear();
}

export function getActiveStreamsCount(): number {
  return activeStreams.size;
}

export function hasActiveStreams(): boolean {
  return activeStreams.size > 0;
}
